<div class="std-margin text-right">
  <date-picker [force]="true" [handler]="handler"></date-picker>
</div>

<panel *ngIf="range && !loading">
  <div header>
    <span>{{'Hạch toán' | lang}} {{range.name}}</span>
    <br/>
    <span class="small uppercase">{{ (sum(expenses.matches, 'Debt', 'VND') == 0 ? 'Đủ điều kiện quyết toán' : 'Chưa đủ điều kiện quyết toán') | lang}}</span>
  </div>

  <table responsive class="data">
    <tr>
      <th priority="3" class="text-top text-right" style="width: 0">STT</th>
      <th priority="1" class="text-top">{{'Hạng mục' | lang}}</th>
      <th priority="2" class="text-top text-right">Công nợ còn lại</th>
      <th priority="2" class="text-top text-right">Đã thanh toán</th>
      <th priority="1" class="text-top text-right">Tổng</th>
    </tr>
    <tr>
      <td class="text-success bold">A</td>
      <td [colSpan]="6" class="secondary text-success">{{'Các khoản ảnh hưởng doanh số' | lang}}</td>
    </tr>
    <tr *ngFor="let i of incomes.matches; index as ix">
      <td><small>{{ix + 1}}</small></td>
      <td>{{name(i.Key) | lang}}</td>
      <td>
        <number [sign]="true" [good]="'none'" [ngClass]="{'text-warning': i.Debt != 0}" [decimal]="0" [value]="value(i, 'Debt', 'VND')"></number><vnd></vnd>
        <div *ngIf="i.Symbol == 'CNY'">
          <number *ngIf="i.Symbol == 'CNY'" class="small" [sign]="false" [good]="'none'" [decimal]="1" [value]="value(i, 'Debt', 'CNY')"></number><cny></cny>
        </div>
      </td>
      <td>
        <number [sign]="true" [good]="'positive'" [decimal]="0" [value]="value(i, 'Paid', 'VND')"></number><vnd></vnd>
        <div *ngIf="i.Symbol == 'CNY'">
          <number *ngIf="i.Symbol == 'CNY'" class="small" [sign]="false" [good]="'none'" [decimal]="1" [value]="value(i, 'Paid', 'CNY')"></number><cny></cny>
        </div>
      </td>
      <td>
        <number [sign]="true" [good]="'positive'" [decimal]="0" [value]="value(i, 'Total', 'VND')"></number><vnd></vnd>
        <div *ngIf="i.Symbol == 'CNY'">
          <number *ngIf="i.Symbol == 'CNY'" class="small" [sign]="false" [good]="'none'" [decimal]="1" [value]="value(i, 'Total', 'CNY')"></number><cny></cny>
        </div>
      </td>
    </tr>

    <tr class=" bold">
      <td></td>
      <td class="text-success nowrap">{{'TỔNG DOANH SỐ' | lang}}</td>
      <td>
        <number [sign]="false" [good]="'none'" [ngClass]="{'text-warning': sum(incomes.matches, 'Debt', 'VND') > 0}" [decimal]="0" [value]="sum(incomes.matches, 'Debt', 'VND')"></number><vnd></vnd>
        <div class="small">{{sum(incomes.matches, 'Debt', 'VND') * 100 / sum(incomes.matches, 'Total', 'VND') | number : '1.1-1' : 'en-US'}}<unit>%</unit></div>
      </td>
      <td>
        <number [sign]="false" [good]="'positive'" [decimal]="0" [value]="sum(incomes.matches, 'Paid', 'VND')"></number><vnd></vnd>
        <div class="small">{{sum(incomes.matches, 'Paid', 'VND') * 100 / sum(incomes.matches, 'Total', 'VND') | number : '1.1-1' : 'en-US'}}<unit>%</unit></div>
      </td>
      <td>
        <number [sign]="false" [good]="'positive'" [decimal]="0" [value]="sum(incomes.matches, 'Total', 'VND')"></number><vnd></vnd>
        <div class="small">100<unit>%</unit></div>
      </td>
    </tr>

    <tr>
      <td class="text-danger bold">B</td>
      <td [colSpan]="5" class="secondary text-danger">{{'Các khoản ảnh hưởng chi phí' | lang}}</td>
    </tr>

    <tr *ngFor="let i of expenses.matches; index as ix">
      <td><small>{{ix + 1}}</small></td>
      <td>{{name(i.Key) | lang}}</td>
      <td>
        <number [sign]="true" [good]="'none'" [ngClass]="{'text-warning': i.Debt != 0}" [decimal]="0" [value]="value(i, 'Debt', 'VND')"></number><vnd></vnd>
        <div *ngIf="i.Symbol == 'CNY'">
          <number class="small" [sign]="true" [good]="'none'" [decimal]="1" [value]="value(i, 'Debt', 'CNY')"></number><cny></cny>
        </div>
      </td>
      <td>
        <number [sign]="true" [good]="'negative'" [decimal]="0" [value]="value(i, 'Paid', 'VND')"></number><vnd></vnd>
        <div *ngIf="i.Symbol == 'CNY'">
          <number class="small" [sign]="true" [good]="'none'" [decimal]="0" [value]="value(i, 'Paid', 'CNY')"></number><cny></cny>
        </div>
      </td>
      <td>
        <number [sign]="true" [good]="'negative'" [decimal]="0" [value]="value(i, 'Total', 'VND')"></number><vnd></vnd>
        <div *ngIf="i.Symbol == 'CNY'">
          <number class="small" [sign]="true" [good]="'none'" [decimal]="0" [value]="value(i, 'Total', 'CNY')"></number><cny></cny>
        </div>
      </td>
    </tr>

    <tr class="bold">
      <td></td>
      <td class="text-danger nowrap">{{'TỔNG CHI PHÍ' | lang}}</td>
      <td>
        <number [sign]="false" [good]="'none'" [ngClass]="{'text-warning': sum(expenses.matches, 'Debt', 'VND') != 0}" [decimal]="0" [value]="sum(expenses.matches, 'Debt', 'VND')"></number><vnd></vnd>
        <div class="small">{{sum(expenses.matches, 'Debt', 'VND') * 100 / sum(incomes.matches, 'Total', 'VND') | number : '1.1-1' : 'en-US'}}<unit>%</unit></div>
      </td>
      <td>
        <number [sign]="false" [good]="'negative'" [decimal]="0" [value]="sum(expenses.matches, 'Paid', 'VND')"></number><vnd></vnd>
        <div class="small">{{sum(expenses.matches, 'Paid', 'VND') * 100 / sum(incomes.matches, 'Total', 'VND') | number : '1.1-1' : 'en-US'}}<unit>%</unit></div>
      </td>
      <td>
        <number [sign]="false" [good]="'negative'" [decimal]="0" [value]="sum(expenses.matches, 'Total', 'VND')"></number><vnd></vnd>
        <div class="small">{{sum(expenses.matches, 'Total', 'VND') * 100 / sum(incomes.matches, 'Total', 'VND') | number : '1.1-1' : 'en-US'}}<unit>%</unit></div>
      </td>

    <tr class="footer bold hidden-until-3">
      <td style="display: none !important"></td>
      <td [colSpan]="2" class="text-top text-primary nowrap">{{sum(incomes.matches, 'Total', 'VND') > sum(expenses.matches, 'Total', 'VND') ? 'TỔNG LỢI NHUẬN' : 'TỔNG THUA LỖ' | lang}}</td>
      <td></td>
      <td></td>
      <td>
        <number [sign]="true" [good]="'positive'" [decimal]="0" [value]="sum(incomes.matches, 'Total', 'VND') - sum(expenses.matches, 'Total', 'VND')"></number><vnd></vnd>
        <div class="small">{{(sum(incomes.matches, 'Total', 'VND') - sum(expenses.matches, 'Total', 'VND')) * 100 / sum(incomes.matches, 'Total', 'VND') | number : '1.1-1' : 'en-US'}}<unit>%</unit></div>
      </td>
    </tr>

    <tr class="footer bold hidden-since-3">
      <td></td>
      <td class="text-top text-primary nowrap">{{sum(incomes.matches, 'Total', 'VND') > sum(expenses.matches, 'Total', 'VND') ? 'TỔNG LỢI NHUẬN' : 'TỔNG THUA LỖ' | lang}}</td>
      <td></td>
      <td></td>
      <td>
        <number [sign]="true" [good]="'positive'" [decimal]="0" [value]="sum(incomes.matches, 'Total', 'VND') - sum(expenses.matches, 'Total', 'VND')"></number><vnd></vnd>
        <div class="small">{{(sum(incomes.matches, 'Total', 'VND') - sum(expenses.matches, 'Total', 'VND')) * 100 / sum(incomes.matches, 'Total', 'VND') | number : '1.1-1' : 'en-US'}}<unit>%</unit></div>
      </td>
    </tr>

  </table>

</panel>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
